import { Button } from '@cian/ui-kit';
import classNames from 'classnames';
import React from 'react';

import { IRosbankBannerComponentProps } from '../../../types/rosbankBanners';
import * as styles from './styles-default.css';

export const RosbankPilotBanner: React.FC<IRosbankBannerComponentProps> = ({ url, onClick }) => {
  return (
    <div className={classNames(styles['container'])} data-testid="rosbank-pilot-banner">
      <a
        href={url}
        rel="noreferrer"
        data-testid="rosbank-pilot-banner-inner-wrapper"
        onClick={onClick}
        className={classNames(styles['wrapper'])}
      >
        <div className={styles['title']}>Обменяйте свою квартиру на квартиру мечты</div>
        <div className={styles['description']}>
          Купите новую квартиру в ипотеку, а потом без спешки продавайте старую
        </div>
        <div className={styles['button']}>
          <Button size="M" theme="fill_primary">
            Подробнее
          </Button>
        </div>
      </a>
    </div>
  );
};
